import { ChevronDown } from 'lucide-react';
import { SidebarItem } from './SidebarItem';
import { isModuleActive } from '../../lib/navigation';

export const SidebarGroup = ({ cat, open, onToggle, collapsed, pathname, onNavigate }) => {
  const Icon = cat.icon;
  const hasActive = cat.items.some((m) => isModuleActive(m, pathname));
  if (collapsed) {
    return (
      <div className="space-y-0.5 pb-2 mb-2 border-b border-border last:border-0" data-testid={`nav-group-${cat.id}`}>
        {cat.items.map((m) => (
          <SidebarItem key={m.id} mod={m} active={isModuleActive(m, pathname)} collapsed onNavigate={onNavigate} />
        ))}
      </div>
    );
  }
  return (
    <div data-testid={`nav-group-${cat.id}`}>
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-[11px] font-semibold uppercase tracking-wider transition-colors
          ${hasActive ? 'text-[hsl(var(--lifeport-red))]' : 'text-muted-foreground hover:text-foreground'}`}
        data-testid={`nav-group-toggle-${cat.id}`}
      >
        <Icon className="h-4 w-4 flex-shrink-0" />
        <span className="flex-1 text-left truncate">{cat.label}</span>
        <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? '' : '-rotate-90'}`} />
      </button>
      <div className={`grid transition-[grid-template-rows] duration-200 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
        <div className="overflow-hidden">
          <div className="pl-2 pb-2 space-y-0.5">
            {cat.items.map((m) => (
              <SidebarItem key={m.id} mod={m} active={isModuleActive(m, pathname)} onNavigate={onNavigate} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
